import { AlertHandlerService } from '../alert-handler.service';
import { LuigiThemingService } from '../luigiNodes/luigi-theming.service';
import { Injectable, inject } from '@angular/core';
import {
  LuigiStaticSettings,
  StaticSettingsConfigService,
} from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class DxpStaticSettingsConfigService
  implements StaticSettingsConfigService
{
  private luigiThemingService = inject(LuigiThemingService);
  private alertHandlerService = inject(AlertHandlerService);

  async getStaticSettingsConfig(): Promise<LuigiStaticSettings> {
    return {
      header: {
        title: 'Hyperspace Portal',
        logo: 'assets/hyperspace-logo.svg',
      },
      responsiveNavigation: 'Fiori3',
      sideNavCompactMode: true,
      customSandboxRules: ['allow-downloads'],
      allowRules: ['local-network-access'],
      featureToggles: {
        queryStringParam: 'ft',
      },
      globalSideNavigation: true,
      burgerTooltip: {
        navExpanded: 'LEFTNAV_COLLAPSE_NAVIGATION',
        navCollapsed: 'LEFTNAV_EXPAND_NAVIGATION',
      },
      profileType: 'Fiori3',
      experimental: {
        webcomponents: true,
        globalNav: true,
        profileMenuFiori3: true,
        navHeader: true,
        breadcrumbs: true,
        globalSearchCentered: true,
        btpToolLayout: true,
      },
      customAlertHandler: this.alertHandlerService.handler,
      backdropDisabled: true,
      appLoadingIndicator: {
        hideAutomatically: false,
      },
      theming: await this.getThemingSettings(),
    };
  }

  private async getThemingSettings() {
    const themeToUse = await this.luigiThemingService.getStoredThemeOrDefault();

    return {
      themes: this.luigiThemingService.getCoreThemes(),
      defaultTheme: themeToUse,
      useFioriScrollbars: true,
      nodeViewURLDecorator: {
        queryStringParameter: {
          keyName: 'sap-theme',
        },
      },
    };
  }
}
